import React, { FunctionComponent, MouseEvent } from 'react'
import { useHistory } from 'react-router'
import { t } from '@lingui/macro'
import { IconButtonProps, LinkBoxProps } from '@chakra-ui/react'
import { LinkBox } from '../link/Link'
import { ButtonIcon } from '../form/button/ButtonChakra'
import IconArrowLeft from '../icon/IconArrowLeft'

export const BackButton: FunctionComponent<
  {
    defaultPath?: string
    variant?: 'link' | 'button'
    className?: string
    beforeHandleNavigation?: () => Promise<any>
  } & Partial<IconButtonProps | LinkBoxProps>
> = ({
  defaultPath,
  variant,
  className,
  children,
  beforeHandleNavigation,
  ...other
}) => {
  const history = useHistory<{ goBackIndex: number }>()

  const handleBackNavigation = async (
    event: MouseEvent<HTMLButtonElement | HTMLDivElement>
  ) => {
    event.preventDefault()
    const { state: { goBackIndex = -1 } = {} } = history.location

    // beforeHandleNavigation is superior to other actions
    if (beforeHandleNavigation) {
      await beforeHandleNavigation()
    }

    // if we have empty navigation history, we will use default static path or home path
    if (!history.location.state || Math.abs(goBackIndex) >= history.length) {
      history.replace(defaultPath || '/')
      return
    }

    if (goBackIndex < -1) {
      history.go(goBackIndex)
    } else {
      history.goBack()
    }
  }

  if (variant === 'link') {
    return (
      <LinkBox
        aria-label={t`Back`}
        className={`back-button ${className}`}
        onClick={handleBackNavigation}
        {...(other as Partial<LinkBoxProps>)}
      >
        <IconArrowLeft />
        {children}
      </LinkBox>
    )
  }

  // TODO: we use this button on topic pages, merge designs and use only one type of back button
  return (
    <ButtonIcon
      aria-label={t`Back`}
      className={`back-button ${className}`}
      icon={<IconArrowLeft />}
      onClick={handleBackNavigation}
      circular
      {...(other as Partial<IconButtonProps>)}
    >
      {children && <span className="label">{children}</span>}
    </ButtonIcon>
  )
}
